import * as React from 'react';

// components
import TranslationsHoverCard from 'chat/components/MessageTranslations/TranslationsHoverCard';

// Stubbed composer class that will hold the implementation
// details ChatBroadcast translations (as opposed to chats).
// Should render generic TranslationsHoverCard presentation component.
export default class TranslationsHoverCardComposer extends React.Component {
  constructor(props: any) {
    super(props)

    this.onTranslateMessage = this.onTranslateMessage.bind(this);
  }

  onTranslateMessage() {}

  render() {
    return (
      <TranslationsHoverCard
        onTranslateMessage={() => this.onTranslateMessage}
      />
    )
  }
}
